import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "flex h-screen",
  "data-testid": "affiliate-layout"
}
const _hoisted_2 = { class: "flex flex-1 flex-col overflow-hidden" }
const _hoisted_3 = {
  class: "flex gap-2 overflow-x-auto border-b border-gray-200 px-4 py-2.5 lg:hidden",
  "aria-label": "Menu do portal",
  "data-testid": "affiliate-mobile-nav"
}
const _hoisted_4 = { class: "flex flex-1 flex-col overflow-y-auto" }
const _hoisted_5 = { class: "flex-1 bg-white px-4 pb-8 pt-2 lg:px-8" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-left text-[13px] text-red-700",
  "data-testid": "affiliate-layout-error"
}
const _hoisted_7 = {
  key: 1,
  class: "h-40 animate-pulse rounded-lg bg-lightGray30",
  "data-testid": "affiliate-layout-loading"
}

import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import EnvironmentStrip from '@/components/EnvironmentStrip.vue'
import Footer from '@/components/Footer.vue'
import AffiliateCompetenceSelect from '@/modules/affiliate/components/AffiliateCompetenceSelect.vue'
import AffiliateHeader from '@/modules/affiliate/components/AffiliateHeader.vue'
import AffiliateImpersonationBanner from '@/modules/affiliate/components/AffiliateImpersonationBanner.vue'
import AffiliatePackageDrawer from '@/modules/affiliate/components/AffiliatePackageDrawer.vue'
import AffiliateSidebar from '@/modules/affiliate/components/AffiliateSidebar.vue'
import { initialsOf } from '@/modules/affiliate/format'
import { AFFILIATE_NAV, AFFILIATE_PAGE_TITLES } from '@/modules/affiliate/labels'
import type { AffiliatePage } from '@/modules/affiliate/labels'
import { useAffiliateCompetence } from '@/modules/affiliate/useAffiliateCompetence'
import { useAffiliatePortalNav } from '@/modules/affiliate/useAffiliateScope'
import { useAntecipeAffiliateStore } from '@/pinia-store/useAntecipeAffiliateStore'
import { useAuthStore } from '@/pinia-store/useAuthStore'
import PATHS from '@/router/paths'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateLayout',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useAntecipeAffiliateStore()
const authStore = useAuthStore()
const { scope, portalLink } = useAffiliatePortalNav()
const { competence, options: competenceOptions, setCompetence } = useAffiliateCompetence()

/** Selo de Pacotes só com o resumo da competência na tela (nunca o número de outra). */
const openCount = computed(() =>
  store.summary && store.summary.competence === competence.value ? store.openPackageCount : null
)

const page = computed<AffiliatePage>(() => route.meta.affiliatePage ?? 'overview')
const titles = computed(() => AFFILIATE_PAGE_TITLES[page.value])
const subtitle = computed(() =>
  store.me
    ? titles.value.subtitle({ name: store.me.affiliate.name, slaHours: store.me.slaHours })
    : ''
)
const initials = computed(() =>
  scope.value.kind === 'admin' ? initialsOf(authStore.getUserName) : (store.me?.user.initials ?? '')
)

// Escopo antes de qualquer página montar (o slot só aparece depois do /me).
watch(
  scope,
  (next) => {
    store.setScope(next)
    void store.loadMe()
  },
  { immediate: true, deep: true }
)

// Quadro de competências (período dos rótulos e tela Repasse): uma vez por escopo.
watch(
  () => store.me,
  (me) => {
    if (me) void store.loadCompetences()
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AffiliateSidebar, {
      class: "hidden lg:flex",
      me: _unref(store).me,
      "current-page": page.value,
      "open-count": openCount.value,
      "portal-link": _unref(portalLink)
    }, null, 8, ["me", "current-page", "open-count", "portal-link"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(EnvironmentStrip),
      (_unref(scope).kind === 'admin')
        ? (_openBlock(), _createBlock(AffiliateImpersonationBanner, {
            key: 0,
            "affiliate-name": _unref(store).me?.affiliate.name ?? 'este afiliado',
            onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(PATHS).ANTECIPE_AFFILIATES)))
          }, null, 8, ["affiliate-name"]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AFFILIATE_NAV), (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.page,
            to: _unref(portalLink)(item.page),
            class: _normalizeClass(["whitespace-nowrap rounded-full border px-3 py-1 text-[13px]", 
            item.page === page.value
              ? 'border-primary bg-primary text-white'
              : 'border-lightGray30 bg-white'
          ])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ]),
      _createVNode(AffiliateHeader, {
        title: titles.value.title,
        subtitle: subtitle.value,
        "show-breadcrumb": page.value !== 'overview',
        "home-link": _unref(portalLink)('overview'),
        initials: initials.value,
        "can-logout": _unref(scope).kind === 'self',
        onLogout: _cache[1] || (_cache[1] = ($event: any) => (_unref(authStore).logout()))
      }, {
        actions: _withCtx(() => [
          (_unref(competence))
            ? (_openBlock(), _createBlock(AffiliateCompetenceSelect, {
                key: 0,
                "model-value": _unref(competence),
                options: _unref(competenceOptions),
                "onUpdate:modelValue": _unref(setCompetence)
              }, null, 8, ["model-value", "options", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "subtitle", "show-breadcrumb", "home-link", "initials", "can-logout"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("main", _hoisted_5, [
          (_unref(store).meError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(store).meError) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded border border-red-200 bg-white px-3 py-1 text-xs font-medium",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(store).loadMe(true)))
                }, " Tentar novamente ")
              ]))
            : (!_unref(store).me)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _renderSlot(_ctx.$slots, "default", { key: 2 })
        ]),
        _createVNode(Footer)
      ])
    ]),
    _createVNode(AffiliatePackageDrawer)
  ]))
}
}

})